/** Shopify CDN: Converted to ES5 **/

if (!customElements.get('product-card')) {

    function Recommendation() {
        // Calling HTMLElement
        var self = Reflect.construct(HTMLElement, [], Recommendation);
        return self;
    }

    Recommendation.prototype = Object.create(HTMLElement.prototype);
    Recommendation.prototype.constructor = Recommendation;

    Recommendation.prototype.connectedCallback = function () {
        var self = this;

        this.handle = this.dataset.handle;

        if (this.handle) {
            this.getProduct().then(function (product) {
                self.product = product;

                self.state = {
                    product: {},
                    siblingProduct: {}
                };

                self.dom = {
                    parentComponent: self.closest('component-recommendations')
                };

                self.props = {
                    parentCollectionHandle: "",
                    swatches: true,
                    productHandle: self.handle,
                    color: self.product.color,
                    id: self.product.id
                };

                self.state.siblingProduct = self.product.colors[self.props.color];
                self.render();
            }).catch(function (err) {
                console.error(err);
            });
        }
    };

    Recommendation.prototype.getProduct = function () {
        var self = this;
        return fetch(window.Shopify.routes.root + 'products/' + this.handle + '?view=featured-product-json', {
            method: "get"
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('HTTP error! status: ' + response.status);
            }
            return response.json();
        });
    };

    Recommendation.prototype.render = function () {
        this.renderSwatches(this);
        this.renderTags();
        this.afterRender();

        // Select first swatch to render the image
        var checkedInput = this.querySelector('.js-colors .first input') || null;

        if (checkedInput) this.selectSwatch(checkedInput);
    };

    Recommendation.prototype.renderSwatches = function (template) {
        if (!this.product || !this.product.colors) return;

        var swatchCount = 0;
        for (var color in this.product.colors) {
            if (this.product.colors[color].available) {
                swatchCount++;
                var colorTemplate = template.querySelector('.js-template-color').content.cloneNode(true);
                if (window.theme.colors[color]) {
                    if (window.theme.colors[color].image) {
                        colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', 'url(' + window.theme.colors[color].image + ')');
                    }
                    colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
                    colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
                }
                if (color === this.props.color) {
                    colorTemplate.querySelector('.js-input').checked = true;
                    colorTemplate.querySelector('.js-color').classList.add("first");
                }
                var labelId = 'color_' + color + '_' + this.product.id + '_template__component_recommendations_bloomreach';
                colorTemplate.querySelector('.js-label').setAttribute('for', labelId);
                colorTemplate.querySelector('.js-label').dataset.color = color;
                colorTemplate.querySelector('.js-input').value = color;
                colorTemplate.querySelector('.js-input').id = labelId;
                this.querySelector('.js-colors').appendChild(colorTemplate);
            }
        }
        if (swatchCount > 4) {
            var colorCountTemplateMobile = template.querySelector('.js-colors').querySelector('.js-template-color-count').content.cloneNode(true);
            var ccMobile = colorCountTemplateMobile.querySelector('.js-color-count');
            if (ccMobile) {
                ccMobile.innerHTML = '+' + (swatchCount - 4);
                ccMobile.classList.add('color-count--mobile');
            }
            template.querySelector('.js-colors').appendChild(colorCountTemplateMobile);
        }
        if (swatchCount > 8) {
            var colorCountTemplateDesktop = template.querySelector('.js-colors').querySelector('.js-template-color-count').content.cloneNode(true);
            var ccDesktop = colorCountTemplateDesktop.querySelector('.js-color-count');
            if (ccDesktop) {
                ccDesktop.innerHTML = '+' + (swatchCount - 8);
                ccDesktop.classList.add('color-count--desktop');
            }
            template.querySelector('.js-colors').appendChild(colorCountTemplateDesktop);
        }
    };

    Recommendation.prototype.renderTags = function () {
        var displayTag;
        for (var tag in this.product.tags) {
            if (typeof this.product.tags[tag] === 'string' && this.product.tags[tag].indexOf("__label:") > -1) {
                displayTag = this.product.tags[tag].replace("__label:", '');
                break;
            }
        }
        if (displayTag) {
            var tagTemplate = this.querySelector('.js-template-tag').content.cloneNode(true);
            var tagText = tagTemplate.querySelector('.js-tag-text');
            if (tagText) tagText.innerHTML = displayTag;
            this.querySelector('.js-tags').append(tagTemplate);
        }
    };

    Recommendation.prototype.afterRender = function () {
        this.handleSwatchChange();
    };

    Recommendation.prototype.handleSwatchChange = function () {
        var self = this;
        this.querySelectorAll('.js-color .js-input').forEach(function (color) {
            color.addEventListener('change', function () {
                self.selectSwatch(color);
            });
        });
    };

    Recommendation.prototype.selectSwatch = function (color) {
        var images = this.product.colors[color.value].images;
        var imageSrc = images[0].src;
        if (images[1]) {
            imageSrc = images[1].src;
        }
        if (this.product.colors[color.value].type === 'Panties') {
            imageSrc = images[0].src;
        }
        this.querySelector('.js-img').src = imageSrc;
        this.querySelector('.js-img').srcset = getSrcset(imageSrc, '900');

        var comparePriceElement = this.querySelector('.js-compare-price');

        this.querySelector('.js-price').innerHTML = toMoney(this.state.siblingProduct.price, { cents: false, no_zeros: true });
        if (comparePriceElement) {
            if (this.state.siblingProduct.compare_at_price > this.state.siblingProduct.price) {
                comparePriceElement.innerHTML = toMoney(this.state.siblingProduct.compare_at_price, { cents: false, no_zeros: true });
            } else {
                comparePriceElement.innerHTML = '';
            }
        }
        var url = this.product.colors[color.value].url;
        if (url) {
            this.querySelectorAll('.js-link').forEach(function (link) {
                link.href = url;
            });
        }
    };

    customElements.define('product-card', Recommendation);
}
